<template>
  <b-modal  ref="modal" visible size="lg" :hide-footer="true" title="inkooporder aanmaken" @hidden="$emit('close')">
      <div class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Inkooporder
        </h3>
      </div>
      <div class="block-content">
          <div class="block-content p-0 row" style="margin-bottom: 10px">
            <input v-model="orderListName" ref="searchInput" class="form-control" :placeholder="`Geef een naam aan de bestelling`">
            <multiselect v-model="supplier" :options="brands" placeholder="Selecteer een leverancier" selected-label="✔" select-label="" deselect-label="✔" style="margin-top: 10px" />
          </div>
      </div>
    </div>
    <div v-if="fromScratch" class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Producten toevoegen
        </h3>
          <button type="submit" class="btn btn-info btn-noborder" style="float: right;" @click="openUnknownProductModal">
            Nieuw product toevoegen aan inkooporder
          </button>
      </div>
        <div class="block-content" >
        <div class="block-content p-0 row">
          <input list="products" v-model="productName" ref="searchInput" v-on:input="getProducts" class="form-control" :placeholder="`Vul een product naam in`">
          <datalist id="products" >
            <option v-for="item in products" :key="item.id">{{item.name}}</option>
          </datalist>
        </div>
          <button type="submit" class="btn btn-success btn-noborder" style="margin-top: 25px;" @click="addProductToOrderList">
            Toevoegen aan inkooporder
          </button>
        </div>
        </div>
    <div v-if="fromScratch" class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Producten in inkooporder
        </h3>
      </div>
          <div class="block-content p-0">
          <table  class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th style="width: 150px;">EAN</th>
                <th>Product</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in orderListProducts" :key="product.id">
                <td>
                  <a class="font-w600" href="#">{{product.gtin}}</a>
                </td>
                <td>{{product.name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    <button type="submit" class="btn btn-success btn-noborder" style="margin-top: 10px" @click="createOrderList">
      Maak een nieuwe inkooporder aan
    </button>
    <unkown-product-modal v-if="showUnknownProductModal" :barcode="unknownProductBarcode" @close="showUnknownProductModal = null, unknownProductBarcode = null" @unkownProductCreated="handleUnkownProductCreated"></unkown-product-modal>
  </b-modal>
</template>
<script>
import http from '../utils/http'
import Socket from '../barcode-scanner/socket'
import UnkownProductModal from '../products/UnkownProductModal.vue'

export default {
  components: {
    UnkownProductModal
  },
  props: {
    productIds: Array,
    fromScratch: Boolean
  },
  data () {
    return {
      orderListName: null,
      supplier: null,
      productName: null,
      products: null,
      orderListProducts: {},
      brands: [],
      showUnknownProductModal: null,
      unknownProductBarcode: null
    }
  },
  methods: {
    createOrderList () {
      var validData = true
      if (!this.orderListName) {
        validData = false
      }
      if (!this.supplier) {
        validData = false
      }
      if (this.productIds.length === 0) {
        validData = false
      }
      if (validData) {
        const data = {
          product_ids: this.productIds,
          supplier: this.supplier,
          name: this.orderListName
        }

        this.$http.post(`/order-list`, data)
        .then((response) => {
          this.$swal('Hoera 😊', `De inkooporder is succesvol aangemaakt.`, 'success')
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de inkooporder. Probeer het opnieuw.`, 'error')
        })
      } else {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de inkooporder. Probeer het opnieuw.`, 'error')
      }
    },
    getProducts () {
      const params = {}
      params[`filter[search]`] = this.productName

      http.get('/products', { params })
        .then((response) => {
          this.products = response.data.data
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het ophalen van de producten. Probeer het opnieuw.`, 'error')
        })
    },
    addProductToOrderList () {
      if (this.products.length > 1) {
        this.$swal('Oeps! 😳', `Selecteer 1 product SVP. Probeer het opnieuw.`, 'error')
      } else {
        this.$set(this.orderListProducts, this.products[0].sku, this.products[0])
        if (!this.productIds.includes(this.orderListProducts[this.products[0].sku].id)) {
          this.productIds.push(this.orderListProducts[this.products[0].sku].id)
        }
      }
    },
    loadBrands () {
      http.get('brands')
      .then((result) => {
        this.brands = result.data.data
      })
    },
    handleMessage (event) {
      http.get(`/product-scanned/${event}`)
        .then((result) => {
          if (result.data.data === 'unknown_product') {
            this.openUnknownProductModal()
            return
          }
          this.$set(this.orderListProducts, result.data.data.sku, result.data.data)
          if (!this.productIds.includes(this.orderListProducts[result.data.data.sku].id)) {
            this.productIds.push(this.orderListProducts[result.data.data.sku].id)
          }
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    handleUnkownProductCreated (event) {
      this.$set(this.orderListProducts, event.product.sku, event.product)
      if (!this.productIds.includes(this.orderListProducts[event.product.sku].id)) {
        this.productIds.push(this.orderListProducts[event.product.sku].id)
      }
    },
    openUnknownProductModal () {
      this.showUnknownProductModal = true
      this.unknownProductBarcode = this.productName
    }
  },
  created () {
    this.loadBrands()
    Socket.$on('message', this.handleMessage)
  },
  beforeDestroy () {
    Socket.$off('message', this.handleMessage)
  }
}
</script>



// WEBPACK FOOTER //
// CreateOrderListModal.vue?1baf5e3c